export const EIMZO_SERVER_URL= 'https://merchant.anorbank.uz/e-imzo-server'